<template>
    <v-app>
        <v-toolbar app :clipped-left="clipped" dense>
            <v-toolbar-title v-text="global.titulo"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu offset-y offset-x left>
                <v-btn icon slot="activator">
                    <v-icon>apps</v-icon>
                </v-btn>
                <v-list>
                    <v-list-tile :to="{path: '/inicio'}">
                        Inicio
                    </v-list-tile>
                    <v-list-tile :to="{path: '/bases/inicio'}">
                        Bases
                    </v-list-tile>
                    <v-list-tile>
                        Tareas
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-menu offset-y offset-x left>
                <v-btn icon slot="activator">
                    <v-avatar size="36">
                        <img src="https://lh3.googleusercontent.com/-0bpANkfEpnQ/AAAAAAAAAAI/AAAAAAAAAAA/APUIFaOKGQFSJomSMh-JI7kwOmpjMvO6oA/s32-c-mo/photo.jpg" alt="avatar">
                    </v-avatar>
                </v-btn>
                <v-list>
                    <v-list-tile @click="logout">
                        Cerrar Sesión
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>

        <v-content>
            <transition name="fade" mode="out-in">
                <router-view :auth="auth" :authenticated="authenticated" @logout="logout" style="height: 100%"></router-view>
            </transition>
        </v-content>

        <v-snackbar
                v-model="global.snack_mostrando"
                bottom
                right
                :timeout="global.snack_tiempo"
        >
            {{ global.snack_texto }}
            <v-btn
                    flat
                    @click="global.snack_mostrando = false"
            >
                X
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import AuthService from './plugins/auth/AuthService'
  const auth = new AuthService()
  const { login, logout, authenticated, authNotifier, isAuthenticated } = auth

  export default {
    name: 'app',
    data () {
      authNotifier.on('authChange', authState => {
        this.authenticated = authState.authenticated
      })

      return {
        auth,
        authenticated,
        clipped: true,
        drawer: true,
        fixed: true,
        items: [
          {
            link: 'inicio',
            icon: 'home',
            title: 'Inicio'
          },
          {
            link: 'proyectos',
            icon: 'settings',
            title: 'Proyectos'
          },
          {
            link: 'helloWorld',
            icon: 'bubble_chart',
            title: 'Inspiración'
          }],
        miniVariant: false,
        right: true,
        rightDrawer: false
      }
    },
    computed: {
      ...mapState({ global: state => state.global }), // general: state => state.general, snack: state => state.snack
    },
    methods: {
      ...mapActions(['cambiarTitulo', 'mostrarSnack', 'ocultarSnack']),
      login,
      logout,
      isAuthenticated
      /*log () {
        login(encodeURIComponent(window.location))
      }*/
    },
    mounted() {
      if(!this.authenticated && this.$route.name !== 'iniciada') {
        login(/*encodeURIComponent(window.location)*/)
      }
    }
  }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .3s;
    }

    .fade-enter-active {
        transition-delay: .3s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }

    .pointer {
        cursor: pointer;
    }
</style>